import type { SignatureContent } from '@/blocks/domain/types/BlockContent/SignatureContent';
import type { BlockContentDto } from '@/blocks/application/mappers/blockMapper';
import { fieldsToDto, mapFieldsDto } from '@/blocks/application/mappers/blockFieldsMapper';

/** `sections` maps only when the wire carries it, so a legacy flat signature round-trips byte for byte. */
export function mapSignatureContent(dto: Extract<BlockContentDto, { kind: 'signature' }>): SignatureContent {
  const content: SignatureContent = { kind: 'signature', fields: mapFieldsDto(dto.fields ?? []) };
  if (dto.sections !== undefined) content.sections = dto.sections;
  return content;
}

export function fromSignatureContent(content: SignatureContent): Extract<BlockContentDto, { kind: 'signature' }> {
  const dto: Extract<BlockContentDto, { kind: 'signature' }> = { kind: 'signature', fields: fieldsToDto(content.fields) };
  if (content.sections !== undefined) dto.sections = content.sections;
  return dto;
}
